module.exports = __webpack_public_path__ + "img/17866_S.2ee2b925.png";